import React, { lazy } from 'react';
import { Instagram, MessageCircle, MapPin, Clock } from 'lucide-react';
export function Footer() {
  return <footer id="contacto" className="relative border-t border-white/10 bg-[#050505] pt-20 pb-10 overflow-hidden" data-id="element-131" data-mp="3ggaohovss12a">
      {/* Top Neon Border Line */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-neon-violet to-transparent opacity-50" data-id="element-132" data-mp="36p6bgupomqa3" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-133" data-mp="3ugbrb9vmhike">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-134" data-mp="38h3d4agb8ib">
          {/* Brand */}
          <div data-id="element-135" data-mp="3lem127dh8po7">
            <div className="flex items-center gap-3 mb-6" data-id="element-136" data-mp="3lf58gu5i3vnz">
              <img src="https://cdn.magicpatterns.com/uploads/r5iC3kC3vE24ymYYnWFYb1/heylloyd-image-1781198268359.png" alt="Ninja 2.0 Logo" className="h-12 w-auto object-contain mix-blend-screen" loading="lazy" decoding="async" width="70" height="70" data-id="element-137" data-mp="3lgop4lv2k8qa" />
              <span className="font-display text-3xl tracking-wider text-transparent bg-clip-text bg-gradient-to-b from-[#F3E08A] via-[#C9A24A] to-[#8A6A1E]" data-id="element-138" data-mp="3l9sjf6xt4wpj">
                NINJA 2.0
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-139" data-mp="3v5dgcqo0r6sf">
              Elevando el arte del cabello al siguiente nivel. Cortes de autor y
              colorimetría avanzada por Nicolas Marshall.
            </p>
          </div>

          {/* Location & Booking */}
          <div data-id="element-140" data-mp="33nogbm61tnc">
            <h2 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-141" data-mp="3230j4ucx8yg">
              Ubicación & Horarios
            </h2>
            <ul className="space-y-4" data-id="element-142" data-mp="curzj08q0ucw">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-143" data-mp="cvto87intfd3">
                <MapPin size={18} className="text-neon-violet shrink-0 mt-0.5" data-id="element-144" data-mp="qu1g410u9qhe" />
                <a href="https://maps.google.com/maps?q=Hugo+Cores+262,+El+Pinar,+Canelones,+Uruguay" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-id="element-145" data-mp="mq3hrsjc8jpe">
                  Hugo Cores 262, El Pinar, Canelones, Uruguay
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-146" data-mp="18lkaznp4qo6c">
                <Clock size={18} className="text-neon-green shrink-0 mt-0.5" data-id="element-147" data-mp="1ckkqaw8ef8ol" />
                <span data-id="element-148" data-mp="1hk5wnrpwejbc">Atención exclusiva con agenda previa.</span>
              </li>
            </ul>

            <a href="https://wa.me/59897581636" target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-neon-violet to-neon-green text-white font-semibold text-sm hover:scale-105 transition-transform shadow-[0_0_20px_rgba(168,85,247,0.2)]" data-id="element-149" data-mp="1mj8qsh4cb54j">
              <MessageCircle size={18} data-id="element-150" data-mp="2aevdxsrcbo5s" />
              Por otras consultas Escríbenos
            </a>
          </div>

          {/* Social */}
          <div data-id="element-151" data-mp="25nlqmyt9kwx2">
            <h2 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-152" data-mp="25n3x49xzkwsu">
              Conecta
            </h2>
            <div className="flex gap-4" data-id="element-153" data-mp="1wnp9di97f0c1">
              <a href="https://instagram.com/barberianinja2.0" target="_blank" rel="noreferrer" aria-label="Visitar nuestro perfil de Instagram" className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 hover:text-neon-violet hover:border-neon-violet/50 transition-all" data-id="element-154" data-mp="1worx5hb8cmnq">
                <Instagram size={20} data-id="element-155" data-mp="2fgayzktipuo6" />
              </a>
              <a href="https://wa.me/59897581636" target="_blank" rel="noreferrer" aria-label="Escríbenos por WhatsApp" className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 hover:text-neon-green hover:border-neon-green/50 transition-all" data-id="element-156" data-mp="18z5yqw2ombgs">
                <MessageCircle size={20} data-id="element-157" data-mp="2iwcgief7mbub" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-158" data-mp="2nrrud6d7w7qq">
          <p className="text-gray-500 text-sm" data-id="element-159" data-mp="3flbv0b6e09uy">
            © 2026 Barbería Ninja 2.0 — Nicolas Marshall.
          </p>
          <p className="text-gray-600 text-xs" data-id="element-160" data-mp="31mc3mvrhpgv3">
            Diseñado para el Siguiente Nivel.
          </p>
        </div>
      </div>
    </footer>;
}